import { CreditCard, HelpOutline, Home, Speed } from '@vst/beam-icons/icons';

import { ROUTES } from '@app/router/constants';
import { NavItem } from '@app/components/HeaderNavigation/types';

// Mobile presentation of the shared navigation tabs. Paths missing here (e.g. the external FAQ /Help) are not shown on mobile.
const MOBILE_TAB_META: Record<string, { labelKey: string; icon: typeof Home }> = {
  [ROUTES.HOME]: { labelKey: 'Overview', icon: Home },
  [ROUTES.BILLING]: { labelKey: 'BillPay', icon: CreditCard },
  [ROUTES.PLAN]: { labelKey: 'Plan', icon: Speed },
  [ROUTES.NETWORK]: { labelKey: 'Help', icon: HelpOutline },
};

export const toMobileTabs = (tabs: NavItem[], t: (key: string) => string) =>
  tabs
    .filter((tab) => MOBILE_TAB_META[tab.path])
    .map((tab) => ({
      ...tab,
      label: t(MOBILE_TAB_META[tab.path].labelKey),
      icon: MOBILE_TAB_META[tab.path].icon,
    }));
